import { useState } from "react"
import { useEffect } from "react";
import { positioning } from "../../services/resultsService";
import { Step } from "../../components/Step/ResultsStep";
import { NextButtonBlack } from "../../components/Buttons/NextButtonBlack";

export const ResultsPositioning = ({ brandName }) => {
    const [hasPaid, setHasPaid] = useState(false);
    const [content, setContent] = useState({
        statement: "Positioning Statement",
        secondaryStatement: "Secondary Statement",
        paragraph: "Content is being loaded"
    });
    const [isLoading, setIsLoading] = useState(true);

    const [companyName, setCompanyName] = useState("Your Company");

    const header = {
        index: "04",
        section: "Positioning",
        company: companyName
    }

    useEffect(() => {
        positioning().then(response => {
            const { positioning, company } = response.data;
            setIsLoading(false);
            if (positioning) {
                setHasPaid(true);
                setContent(JSON.parse(positioning))
            }
            company ? setCompanyName(company) : setCompanyName('Your Company');
        }).catch(error => {
            const status = error.response.status;
            setIsLoading(false);
            if (status === 403) {
                setHasPaid(false);
            }
        });
    }, []);

    const handleClick = () => {
        window.location.href = "/flow/checkout"
    }

    return (
        <Step header={header}>
            {hasPaid ? (
                <>
                    <h1 className="results__title">
                        {content.statement}
                    </h1>
                    <h2 className="results__subtitle">
                        {content.secondaryStatement}
                    </h2>
                    <p className="results__description">
                        {content.paragraph}
                    </p>
                </>
            ) : (
                <>
                    <h1 className="results__title statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)" }}>
                        {content.statement}
                    </h1>
                    <h2 className="results__subtitle statement__paidText" style={{ textShadow: "0px 0px 10px rgb(255 255 255)", color: "transparent" }}>
                        {content.secondaryStatement}
                    </h2>
                    <p className="results__description statement__paidText" style={{ textShadow: "0px 0px 10px rgb(255 255 255)", color: "transparent" }}>
                        {content.paragraph}
                    </p>
                    {!isLoading && (
                        <div className="flex gap-8 items-center">
                            <p className="results__description" style={{ width: 'max-content' }}>
                                Please complete payment in order to view the positioning <br /> statements and the associated description.
                            </p>
                            <button className="btn prev" onClick={handleClick}>
                                <NextButtonBlack isYellow />
                            </button>
                        </div>
                    )}
                </>
            )}

        </Step>
    )
}